<div class="flex flex-wrap lg:flex-nowrap gap-6 mt-5">
  <div class="card w-full lg:w-1/2">
    <h5 class="font-bold">Identificação do Produto</h5>
    <p>Adicionar os identificadores do produto para vincular ao pedido.</p>

    <div class="bg-gray-200 rounded-lg p-2 mt-5">
      <p>
        <span class="font-bold">1 - Produto - </span>
        Conferir cor e capacidade
      </p>
    </div>

    <div class="flex w-full gap-5 mt-5 items-center">
      <div class="bg-gray-100 h-30 text-center relative rounded-lg">
        <img
          [src]="product()?.mainImageUrl ?? ''"
          class="h-29 object-cover rounded-lg"
        />
      </div>
      <div class="w-full">
        <p class="font-bold">
          {{
            product()!.modelVersionName ||
              product()!.modelName ||
              product()!.name ||
              "-"
          }}
        </p>
        <p class="mt-1">SKU: {{ product()!.sku }}</p>
      </div>
    </div>

    <div class="bg-gray-200 rounded-lg p-2 mt-5">
      <p>
        <span class="font-bold">2 - </span>
        Informe os identificadores (ex: IMEI, Número de Série) do produto
      </p>
    </div>

    @if (!productIdentifiersLocked()) {
      <div class="flex justify-end mt-5">
        <p-button
          type="button"
          label="Adicionar identificador"
          (click)="addProductIdentifier()"
          severity="secondary"
          class="btn-secondary-outline"
          rounded
        ></p-button>
      </div>
    }

    <form [formGroup]="formGroup">
      <div formArrayName="productIdentifiers">
        @if (productIdentifiersArray.controls.length === 0) {
          <p class="text-sm text-gray-500 text-center mt-2">
            Nenhum identificado adicionado.
          </p>
        }
        @for (
          group of productIdentifiersArray.controls;
          let i = $index;
          track i
        ) {
          <div [formGroupName]="i" class="mt-5">
            <div
              class="w-full flex flex-wrap items-center md:flex-nowrap gap-4"
            >
              <div class="w-full">
                <label>Identificador *</label>
                <p-select
                  [options]="productIdentifierDropdown()[i] || []"
                  [loading]="productIdentifierLoading()[i] || false"
                  formControlName="productIdentifierTypeId"
                  optionLabel="label"
                  [filter]="true"
                  filterBy="label"
                  [showClear]="true"
                  placeholder="Selecione o identificador"
                  class="w-full"
                  (onChange)="onProductIdentifierChange(i, $event.value)"
                >
                </p-select>
                <app-form-error
                  [control]="
                    getProductIdentifierControl(i, 'productIdentifierTypeId')
                  "
                />
                <app-form-server-error
                  [control]="
                    getProductIdentifierControl(i, 'productIdentifierTypeId')
                  "
                />
              </div>

              <div class="w-full">
                <label>Valor *</label>
                <input
                  pInputText
                  type="text"
                  formControlName="value"
                  class="w-full"
                  placeholder="Informe o valor"
                />
                <app-form-error
                  [control]="getProductIdentifierControl(i, 'value')"
                />
                <app-form-server-error
                  [control]="getProductIdentifierControl(i, 'value')"
                />
              </div>
              @if (!productIdentifiersLocked()) {
                <div class="text-right lg:mt-3">
                  <p-button
                    type="button"
                    icon="ph-duotone ph-trash text-2xl text-red-800"
                    (click)="removeProductIdentifier(i)"
                    link
                  ></p-button>
                </div>
              }
            </div>
          </div>
        }
      </div>

      @if (!productIdentifiersLocked()) {
        <div class="flex justify-end mt-5">
          <p-button
            type="button"
            label="Salvar"
            rounded
            [disabled]="
              formGroup.invalid || productIdentifiersArray.length === 0
            "
            (click)="saveProductIdentifiers()"
          ></p-button>
        </div>
      }
    </form>

    @if (loading()) {
      <div
        class="absolute inset-0 z-9999 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
      >
        <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
      </div>
    }
  </div>
  <div class="card w-full lg:w-1/2">
    <h5 class="font-bold">Checklist de Montagem</h5>
    <p>
      Confira cada item inserido na caixa para o despacho na transportadora.
    </p>

    <div class="bg-gray-200 rounded-lg p-2 mt-5">
      <p>
        <span class="font-bold">3 - </span>
        Monte a
        <span class="font-bold"> caixa para envio </span>
      </p>
    </div>

    <div class="bg-gray-200 rounded-lg p-2 mt-2">
      <p>
        <span class="font-bold">4 - Forre a caixa </span>
        com papel de seda
      </p>
    </div>

    <div class="bg-gray-200 rounded-lg p-2 mt-2">
      <p>
        <span class="font-bold">5 - </span>
        Adicione o <span class="font-bold">Produto</span>
      </p>
    </div>

    <div class="bg-gray-200 rounded-lg p-2 mt-2">
      <p>
        <span class="font-bold">6 - </span>
        Adicione a
        <span class="font-bold"> Película de Vidro </span>
        no modelo correto
      </p>
    </div>

    <div class="bg-gray-200 rounded-lg p-2 mt-2">
      <p>
        <span class="font-bold">7 - </span>
        Adicione a
        <span class="font-bold"> Capinha </span>
        no modelo correto
      </p>
    </div>

    <div class="bg-gray-200 rounded-lg p-2 mt-2">
      <p>
        <span class="font-bold">8 - </span>
        Adicione o
        <span class="font-bold"> Carregador SEM </span>
        a caixa do fabricante
      </p>
    </div>

    <div class="bg-gray-200 rounded-lg p-2 mt-2">
      <p>
        <span class="font-bold">9 - </span>
        Adicione o
        <span class="font-bold"> Brinde Personalizado </span>
      </p>
    </div>

    <div class="bg-gray-200 rounded-lg p-2 mt-2">
      <p>
        <span class="font-bold">10 - </span>
        Adicione o
        <span class="font-bold"> Cartão de Boas-Vindas </span>
      </p>
    </div>

    <div class="bg-gray-200 rounded-lg p-2 mt-2">
      <p>
        <span class="font-bold">11 - </span>
        Cole o
        <span class="font-bold"> Lacre Bemine </span>
        para selar a caixa
      </p>
    </div>
  </div>
</div>
